import {Component, Input, OnInit} from '@angular/core';
import {EmployeeJobCode, IEmployee} from '@signal/asp-data-commons';
import {getEmployeeNameInitials, titleCase} from '../../services/util.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss']
})
export class EmployeeComponent implements OnInit {
  @Input() employee: IEmployee;

  employeeJobCodeShort: string;
  isTechnician: boolean;
  constructor(private readonly translate: TranslateService) {
  }

  ngOnInit() {
    this.employeeJobCodeShort = this.employee.jobCode === EmployeeJobCode.ADVISOR ? 'SA' : 'Tech.';
    this.isTechnician = this.employee.jobCode === EmployeeJobCode.TECHNICIAN;
  }

  getEmployeeInitials(): string {
    return getEmployeeNameInitials(this.employee);
  }
  getTranslation(title:string){
    if(title){
      const value:string[]=title.split(' ');
      const joinedvalue:string=value.join("");
      const key:string=joinedvalue[0].toLowerCase() + joinedvalue.substr(1,joinedvalue.length-1);
      return key ? this.translate.instant(`teamManagement.${key}`) : title;
    }
    return title;
  }
}
